module.exports = require('./build/timsort.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/timsort/index.js
// module id = 83
// module chunks = 0